export default "https://cdn-web.disco.co/slack-mobile-carousel-background-7cdd7194b39dc79eae9493677efc5181.png";